import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import moment from 'moment';

import { assets } from '../../assets/';

const useStyles = makeStyles({
  root: {
    width: 300,
  },
  PrivateValueLabel: {
    circle: { textAlign: 'center' },
  },
});

// Returns an array of dates between the two dates
const getDates = (startDate, endDate) => {
  var dates = [],
    currentDate = startDate,
    addDays = function(days) {
      var date = new Date(this.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };
  while (currentDate <= endDate) {
    dates.push(currentDate);
    currentDate = addDays.call(currentDate, 1);
  }
  return dates;
};

// Usage
let startOfDateSlider = moment()
  .startOf('year')
  .toDate();
let endOfDateSlider = moment()
  .endOf('year')
  .toDate();

var dates = getDates(startOfDateSlider, endOfDateSlider);

let sliderDates = dates.map(function(date) {
  return {
    value: parseInt(moment(date).format('DDD'), 10),
    label: moment(date).format('DD MMM'),
  };
});

function valuetext(value) {
  let index = sliderDates.findIndex(date => date.value === value);
  return `${sliderDates[index].label}`;
}

export default function DiscreteSlider() {
  const classes = useStyles();
  const [value, setValue] = React.useState([254, 364]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const MySlider = withStyles({
    root: {
      textAlign: 'center',
      color: '#F87733',
      circle: {
        textAlign: 'center',
      },
    },
    circle: {
      textAlign: 'center',
    },
  })(Slider);

  return (
    <div className={classes.root}>
      <Typography id="dates-slider" color="inherit" variant="caption">
        <img
          src={assets.icons.calendarIcon}
          alt="calendar_icon"
          style={{
            maxHeight: 16,
            marginRight: 5,
          }}
        />
        Période
      </Typography>
      <div className={classes.margin} />
      <MySlider
        value={value}
        onChange={handleChange}
        valueLabelDisplay="on"
        aria-labelledby="dates-slider"
        valueLabelFormat={valuetext}
        //marks={sliderDates}
        min={1}
        max={364}
        step={1}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/commons/DatesSlider.js